import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
//支付总订单
export function appUserPayOrder(data){
	return post('/admin/appCUserorder/appUserPayOrder',data)
}
//支付子订单
export function appUserPayBackstage(data){
	return post('/admin/appCUserorder/appUserPayBackstage',data)
}
// 全部订单详情
export function appUserFindByOrerInfo(data){
	return post('/admin/appCUserorder/appUserFindByOrerInfo',data)
}
// 微信===判断订单是否支付
export function wxPayState(data){
	return post('/admin/appCUserorder/wxPayState',data)
}